import { styled } from '../../style/theme/themeModule';

export const GroupLabel = styled.div`
  font-weight: ${(p) => p.theme.fontWeight.normal};
  margin-bottom: 10px;
`;
